import React, { useCallback } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

const Checkbox = React.memo((props) => {
  const { checked, indeterminate, onChange, data, label, disabled } = props

  const innerClassName = cx('relative flex items-center justify-center w-4 h-4 border-2 rounded', {
    'border-primary': checked,
    'border-gray-400': !checked,
    'opacity-30': disabled,
  })

  const handleClick = useCallback(() => {
    !disabled && onChange && onChange(!checked, data)
  }, [checked, onChange, disabled])

  return (
    <div
      data-checked={checked}
      data-disabled={disabled}
      data-indeterminate={indeterminate}
      onClick={handleClick}
      className={`flex h-5 items-center ${disabled ? 'cursor-not-allowed' : 'cursor-pointer'}`}
    >
      <div className={innerClassName}>
        {checked && <span className="h-2 w-2 rounded-sm bg-primary" />}
        {indeterminate && <span className="h-1 w-2 rounded-sm bg-primary" />}
      </div>
      <span className="ml-2 text-sm text-gray-500">{label}</span>
    </div>
  )
})

export const CheckboxGroup = React.memo((props) => {
  const { value, onChange, className, options } = props

  const handleCheck = useCallback(
    (checked, data) => {
      onChange && onChange(!checked ? value.filter((item) => item !== data.value) : value.concat(data.value))
    },
    [value, onChange]
  )

  return (
    <div className={`flex items-center space-x-6 font-medium ${className}`}>
      {options.map((option) => (
        <Checkbox key={option.value} checked={value.includes(option.value)} label={option.label} data={option} onChange={handleCheck} />
      ))}
    </div>
  )
})

CheckboxGroup.defaultProps = {
  value: [],
  className: '',
}

CheckboxGroup.emptyChecker = (value) => {
  return Array.isArray(value) && value.length > 0
}

Checkbox.propTypes = {
  value: PropTypes.any,
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  indeterminate: PropTypes.bool,
  onChange: PropTypes.func,
  label: PropTypes.string,
}

export default Checkbox
